import { CommonModule } from '@angular/common';
import { Component, HostListener, OnInit, ChangeDetectionStrategy } from '@angular/core';
import { Router } from '@angular/router';
import { FontAwesomeModule } from '@fortawesome/angular-fontawesome';
import { OAuthService } from 'angular-oauth2-oidc';
import { BsDropdownModule } from 'ngx-bootstrap/dropdown';
import { faBars, faUser } from '@fortawesome/free-solid-svg-icons';

@Component({
    selector: 'app-header',
    imports: [CommonModule, BsDropdownModule, FontAwesomeModule],
    templateUrl: './header.component.html',
    changeDetection: ChangeDetectionStrategy.Eager,
    styleUrl: './header.component.scss'
})
export class HeaderComponent implements OnInit {
  bars = faBars;
  user = faUser;
  isLogged = false;
  iconCloseRotate = false;
  iconHidden = 'chevron-right';
  iconvisible = 'chevron-left'
  sidebarHidden = false;
  scrolled = false;

  url: string = "";

  constructor(
    private router: Router,
    private oAuthService: OAuthService) {

    }


  ngOnInit() {
    if (this.oAuthService.getIdentityClaims()) {
      this.isLogged = true;
    }
  }

  @HostListener("window:scroll", [])
    onWindowScroll() {
        this.scrolled = window.scrollY > 0;
    }

  login() {
    this.oAuthService.initLoginFlow();
  }

  logout() {
    this.oAuthService.logOut(false);
    this.isLogged = false;
    this.router.navigate(['acceso'])

  }

  public get userName() {
    let claims = this.oAuthService.getIdentityClaims() as any;
    if (!claims) return null;
    
    if (claims['given_name']) return claims['given_name'];
    return claims['preferred_name'];
  }

  public get accessTokenExp() {
    let ticks = this.oAuthService.getAccessTokenExpiration();
    let seconds = ticks / 1000;
    let date = new Date('1970-01-01T00:00:00')
    date.setSeconds(seconds);
    return date;
  }

  hideSideBar() {

    let sidebar = document.getElementById('sidebar');
    let rSide = document.getElementById('rSide');

    if(sidebar === null || rSide === null)
    {
      return;
    }

    if (sidebar.classList.contains('hide')) {
      this.sidebarHidden = false;
      sidebar.classList.remove('hide');
      rSide.classList.remove('rSide-full');
    } else {
      this.sidebarHidden = true;
      sidebar.classList.add('hide');
      rSide.classList.add('rSide-full');
    }

    //asd.setAttribute('class', 'menu hide');
  }

}
